import api from "./api";
import { Category, FoodItem } from "../model/types";

export const getCategories = async (): Promise<Category[]> => {
  const response = await api.get<Category[]>("/categories");
  return response.data;
};

export const createCategory = async (payload: {
  name: string;
  description: string;
}): Promise<Category> => {
  const response = await api.post<Category>("/categories", payload);
  return response.data;
};

export const updateCategory = async (
  categoryId: number,
  payload: { name: string; description: string }
): Promise<Category> => {
  const response = await api.put<Category>(`/categories/${categoryId}`, payload);
  return response.data;
};

export const deleteCategory = async (categoryId: number) => {
  await api.delete(`/categories/${categoryId}`);
};

export const getFoods = async (availableOnly = false): Promise<FoodItem[]> => {
  const response = await api.get<FoodItem[]>("/foods", {
    params: { availableOnly },
  });
  return response.data;
};

export const createFood = async (payload: {
  name: string;
  description: string;
  price: number;
  stockQuantity: number;
  status: "AVAILABLE" | "OUT_OF_STOCK";
  categoryId: number;
}): Promise<FoodItem> => {
  const response = await api.post<FoodItem>("/foods", payload);
  return response.data;
};

export const updateFood = async (
  foodId: number,
  payload: {
    name: string;
    description: string;
    price: number;
    stockQuantity: number;
    status: "AVAILABLE" | "OUT_OF_STOCK";
    categoryId: number;
  }
): Promise<FoodItem> => {
  const response = await api.put<FoodItem>(`/foods/${foodId}`, payload);
  return response.data;
};

export const deleteFood = async (foodId: number) => {
  await api.delete(`/foods/${foodId}`);
};
